import { useEffect, useState } from "react";
import "./Explore.css";

/**NEW DESIGN
 * <script async src="https://cse.google.com/cse.js?cx=137437fe1cda44676"></script>
 * <div class="gcse-searchbox-only"></div>
 * @returns
 */

export default function Explore() {
  const [value, setValue] = useState("");

  const changeName = ()=>{
    let changeDivContent = document.querySelector(".gcsc-find-more-on-google");

    if (document.contains(changeDivContent)) {
      document.querySelector(".gcsc-find-more-on-google").lastChild.innerHTML =
        " by nGen DevHub";
    }
  }

  useEffect(() => {
    (function () {
      const cx = "137437fe1cda44676";
      const gcse = document.createElement("script");
      gcse.type = "text/javascript";
      gcse.async = true;
      gcse.src = `https://cse.google.com/cse.js?cx=${cx}`;
      const s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(gcse, s);
    })();

    var renderSearchForms = function () {
      if (document.readyState === "complete") {
        window.google.search.cse.element.render({
          div: "googlesearch",
          tag: "search",
          gname: "gsearch",
        });
      } else {
        window.google.setOnLoadCallback(function () {
          window.google.search.cse.element.render({
            div: "googlesearch",
            tag: "search",
            gname: "gsearch",
          });
        }, true);
      }
    };

    window.__gcse = {
      parsetags: "explicit",
      callback: renderSearchForms,
    };
  }, []);

  useEffect(() => {
    const input = document.getElementById("search");
    const submit = (e) => {
      if (e.keyCode === 13) {
        const element = window.google.search.cse.element.getElement("gsearch");

        element.execute(value);
      }
    };
    input.addEventListener("keyup", submit);

    return () => input.removeEventListener("keyup", submit);
  }, [value]);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <div className="feed__container">
      <div className="ngen__search">
        <input
          name="search"
          className="g__search-input"
          id="search"
          type="text"
          placeholder="Explore"
          value={value}
          onChange={handleChange}
        />
      </div>
      <div className="main__feed-container">
        <div id="googlesearch"></div>
        <div class="gcse-searchresults-only"></div>
      </div>
    </div>
  );
}
